import axios from "axios";
import { UploadImportFileRequest } from "../../../types/interfaces/file/imports";
import { UploadInterpretationsResponse } from "../../../types/interfaces/file/imports/flowTestInterpretations";
import { SessionStore } from "../../../types/store/SessionStore";
import { newAbortSignal } from "../../../utils";

const BASE_URL = `${process.env.REACT_APP_BACKEND_URL}/flow-tests`;

export const uploadInterpretationsFile = async (
  flowTestId: number,
  uploadInfo: UploadImportFileRequest,
): Promise<UploadInterpretationsResponse> => {
  const session: SessionStore | undefined = JSON.parse(
    localStorage.getItem("session") || "{}",
  );

  const formData = new FormData();
  formData.append("interpretationXLSX", uploadInfo.file);

  const res = await axios.post<UploadInterpretationsResponse>(
    `${BASE_URL}/${flowTestId}/interpretations/upload/validate`,
    formData,
    {
      headers: {
        "content-type": "multipart/form-data",
        "x-access-token": session?.accessToken,
      },
      timeout: Number.parseInt(`${process.env.REACT_APP_AXIOS_TIME_OUT}`),
      signal:
        AbortSignal.timeout === undefined
          ? newAbortSignal(Number(process.env.REACT_APP_AXIOS_TIME_OUT))
          : AbortSignal.timeout(Number(process.env.REACT_APP_AXIOS_TIME_OUT)),
    },
  );

  return res.data;
};
